import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'SGE - ADEOTI SA';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboard`;
export const UNAUTHENTICATED_ENTRY = '/login'
export const LOCATION_KEY = 'user_location_granted';


export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'fr',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#2c63b8',      // ancien #3e82f7 → ~50% plus sombre
	headerNavColor: '#602610',   // ancien #903814 → ~50% plus sombre
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false,

	customAntdTheme: {
		token: {
			// BORDURES et couleurs assombries
			// colorBorder: '#808080',          // ancien #bfbfbf
			// colorBorderSecondary: '#999999', // ancien #d1d1d1
			// colorSplit: '#a6a6a6',          // ancien #e0e0e0
			// colorBgContainer: '#f0f0f0',    // ancien #ffffff
			// colorFill: '#cccccc',           // ancien #f5f5f5
		},
		// components: {
		// 	Input: {
		// 		colorText: '#3f3f3f',            // ancien #404040 → -2%
		// 		colorBorder: '#c4c4c4',          // ancien #bfbfbf → -2%
		// 		colorTextPlaceholder: '#a3a3a3'  // ancien #a6a6a6 → -2%
		// 	},
		//
		// 	Select: {
		// 		colorText: '#3d3d3d',
		// 		colorBorder: '#c4c4c4',
		// 	},
		//
		// 	DatePicker: {
		// 		colorText: '#3d3d3d',
		// 		colorBorder: '#c4c4c4',
		// 	},
		//
		// 	Table: {
		// 		colorText: '#262626',
		// 		borderColor: '#c4c4c4',
		// 	},
		//
		// 	Button: {
		// 		colorText: '#262626',
		// 		borderColor: '#c4c4c4',
		// 	},
		//
		// 	Descriptions: {
		// 		colorText: '#262626',
		// 		borderColor: '#c4c4c4',
		// 	}
		// }
	}

	// customAntdTheme: {
	// 	token: {
	// 		// Tokens globaux assombris de 10%
	// 		colorText: '#161616',              // au lieu de #000000E0
	// 		colorTextSecondary: '#262626',     // au lieu de #000000A6
	// 		colorTextPlaceholder: '#8f8f8f',   // au lieu de #a6a6a6
	// 		colorBorder: '#c4c4c4',            // au lieu de #d9d9d9
	// 		colorBorderSecondary: '#d9d9d9',   // au lieu de #f0f0f0
	// 		colorBgContainer: '#f2f2f2',       // au lieu de #ffffff
	// 		colorBgElevated: '#f2f2f2',        // au lieu de #ffffff
	// 		colorBgLayout: '#eaeaea',          // au lieu de #f5f5f5
	// 		colorFill: '#00000021',            // au lieu de #00000026
	// 		colorPrimary: '#146be6',           // au lieu de #1677ff
	// 		colorSuccess: '#4ab418',           // au lieu de #52c41a
	// 		colorWarning: '#e09912',           // au lieu de #faad14
	// 		colorError: '#e64547',             // au lieu de #ff4d4f
	// 		colorInfo: '#146be6'               // aligné sur primary
	// 	},

	// 	components: {
	// 		Button: {
	// 			colorPrimary: '#146be6',
	// 			colorPrimaryHover: '#3586f0',
	// 			colorPrimaryActive: '#0c4ba6',
	// 			colorBorder: '#c4c4c4'
	// 		},
	// 		FloatButton: {
	// 			colorPrimary: '#146be6'
	// 		},
	// 		Typography: {
	// 			colorText: '#161616',
	// 			colorTextSecondary: '#262626'
	// 		},
	// 		Layout: {
	// 			bodyBg: '#eaeaea',
	// 			headerBg: '#0b1a26',
	// 			headerColor: '#f2f2f2',
	// 			siderBg: '#0b1a26',
	// 			triggerBg: '#11263b',
	// 			triggerColor: '#f2f2f2',
	// 			footerBg: '#eaeaea'
	// 		},
	// 		Divider: {
	// 			colorSplit: '#d9d9d9'
	// 		},
	// 		Anchor: {
	// 			colorSplit: '#d9d9d9'
	// 		},
	// 		Breadcrumb: {
	// 			itemColor: '#262626'
	// 		},
	// 		Menu: {
	// 			itemBg: '#f2f2f2',
	// 			itemColor: '#161616',
	// 			itemHoverBg: '#d9e0f5',
	// 			itemHoverColor: '#161616',
	// 			itemSelectedBg: '#c2d3f5',
	// 			itemSelectedColor: '#146be6',
	// 			darkItemBg: '#0b1a26',
	// 			darkItemColor: '#bfbfbf',
	// 			darkItemSelectedBg: '#146be6',
	// 			darkItemSelectedColor: '#f2f2f2'
	// 		},
	// 		Pagination: {
	// 			itemActiveBg: '#c2d3f5',
	// 			itemSelectedColor: '#146be6'
	// 		},
	// 		Steps: {
	// 			colorSplit: '#d9d9d9'
	// 		},
	// 		Tabs: {
	// 			itemSelectedColor: '#146be6',
	// 			inkBarColor: '#146be6'
	// 		},
	// 		Input: {
	// 			colorBgContainer: '#f2f2f2',
	// 			colorText: '#161616',
	// 			colorBorder: '#c4c4c4',
	// 			colorTextPlaceholder: '#8f8f8f'
	// 		},
	// 		Select: {
	// 			colorBgContainer: '#f2f2f2',
	// 			colorText: '#161616',
	// 			colorBorder: '#c4c4c4'
	// 		},
	// 		Checkbox: {
	// 			colorPrimary: '#146be6'
	// 		},
	// 		Radio: {
	// 			colorPrimary: '#146be6'
	// 		},
	// 		Switch: {
	// 			colorPrimary: '#146be6',
	// 			colorTextQuaternary: '#8f8f8f'
	// 		},
	// 		DatePicker: {
	// 			colorBgContainer: '#f2f2f2',
	// 			colorText: '#161616',
	// 			colorBorder: '#c4c4c4',
	// 			colorTextPlaceholder: '#8f8f8f'
	// 		},
	// 		Slider: {
	// 			colorPrimary: '#146be6',
	// 			trackBg: '#c4c4c4'
	// 		},
	// 		Transfer: {
	// 			colorBgContainer: '#f2f2f2'
	// 		},
	// 		Upload: {
	// 			actionsColor: '#161616'
	// 		},
	// 		Card: {
	// 			colorBgContainer: '#f2f2f2',
	// 			borderColor: '#d9d9d9',
	// 			colorTextHeading: '#161616'
	// 		},
	// 		Collapse: {
	// 			headerBg: '#f2f2f2',
	// 			contentBg: '#f2f2f2'
	// 		},
	// 		Descriptions: {
	// 			labelBg: '#eaeaea',
	// 			borderColor: '#c4c4c4'
	// 		},
	// 		List: {
	// 			borderColor: '#c4c4c4'
	// 		},
	// 		Popover: {
	// 			colorBgElevated: '#f2f2f2',
	// 			colorText: '#161616'
	// 		},
	// 		Tooltip: {
	// 			colorBgSpotlight: '#2a2a2a',
	// 			colorText: '#f2f2f2'
	// 		},
	// 		Table: {
	// 			colorBgContainer: '#f2f2f2',
	// 			borderColor: '#c4c4c4',
	// 			headerBg: '#eaeaea',
	// 			rowHoverBg: '#e0e0e0'
	// 		},
	// 		Tag: {
	// 			defaultBg: '#eaeaea',
	// 			defaultColor: '#161616',
	// 			colorBorder: '#c4c4c4'
	// 		},
	// 		Timeline: {
	// 			tailColor: '#c4c4c4',
	// 			dotBg: '#f2f2f2'
	// 		},
	// 		Alert: {
	// 			colorSuccess: '#4ab418',
	// 			colorInfo: '#146be6',
	// 			colorWarning: '#e09912',
	// 			colorError: '#e64547'
	// 		},
	// 		Drawer: {
	// 			colorBgElevated: '#f2f2f2'
	// 		},
	// 		Modal: {
	// 			colorBgContainer: '#f2f2f2',
	// 			colorText: '#161616',
	// 			colorBgMask: 'rgba(0,0,0,0.55)'
	// 		},
	// 		Notification: {
	// 			colorBgElevated: '#f2f2f2'
	// 		},
	// 		Popconfirm: {
	// 			colorBgElevated: '#f2f2f2'
	// 		},
	// 		Progress: {
	// 			defaultColor: '#146be6',
	// 			remainingColor: '#d9d9d9'
	// 		}
	// 	}
	// }
};
